<template>
  <div class="dashboard">
    <nav class="navbar navbar-dark bg-dark flex-nowrap px-3">
      <a class="navbar-brand" href="#">CashFlo Dashboard</a>

      <span class="navbar-text px-3 ml-auto">You're logged in as <strong :title="email">{{firstName}}</strong>.</span>

      <ul class="navbar-nav">
        <li class="nav-item text-nowrap">
          <BasicButton
            class="btn-outline-light"
            :isProcessing="isProcessing"
            @click="onSignOut"
          >
            Sign out
          </BasicButton>
        </li>
      </ul>
    </nav>

    <section class="dashboard__wrapper">
      <DashboardSidebar />

      <main class="dashboard__view py-3">
        <slot />
      </main>
    </section>
  </div>
</template>

<script>
  import get from 'lodash/get'

  import RequestMixin from '@/mixins/RequestMixin'

  import BasicButton from '@/components/BasicButton'
  import DashboardSidebar from '@/components/DashboardSidebar'

  export default {
    mixins: [
      RequestMixin,
    ],

    components: {
      BasicButton,
      DashboardSidebar,
    },

    computed: {
      firstName() {
        return get(this.$store.getters, 'user.firstName', '')
      },

      email() {
        return get(this.$store.getters, 'user.email', '')
      },

      isLoggedIn() {
        return this.$store.getters.isLoggedIn
      },
    },

    methods: {
      async onSignOut() {
        this.handleRequest(this.signOut)
      },

      async signOut() {
        await this.$store.dispatch('signOut')
      },
    },

    watch: {
      isLoggedIn() {
        if (!this.isLoggedIn)
          this.$router.push({
            name: 'login',
          })
      },
    },
  }
</script>

<style lang="scss" scoped>
  @import "@/styles/_variables.scss";

  .dashboard {
    height: 100%;
    display: flex;
    flex-direction: column;

    &__wrapper {
      display: flex;
      flex: 1 1 100%;
    }

    &__view {
      flex: 1 1 100%;
      overflow-y: scroll;
    }
  }
</style>
